import React, { useState } from "react";
import Header from "../../../../../layout/header/allRequest/Header";
import { cleanJoin } from "../../../../../utils/stringUtil";
import TableRows from "./TableRows";

function ResultsTable({ data }) {
  const [tableWidth, setTableWidth] = useState("100%");

  // const columnMapper = {
  //   department: "Upravni odjel",
  //   solver: "Rješavatelj",
  //   submittedBy: "Podnositelj zahtjeva",
  //   subject: "Klasa",
  //   title: "Vrsta zahtjeva",
  //   statusText: "Status",
  //   uid: "uid",
  // };

  const rowMapper = {
    department: "Upravni odjel",
    solver: "Rješavatelj",
    submittedBy: "Podnositelj zahtjeva",
    subject: "Klasa",
    title: "Vrsta zahtjeva",
    statusText: "Status",
  };

  const parseColumns = (columns) => {
    if (columns) {
      return Object.keys(columns)
        .filter((key) =>
          ["department", "solver", "submittedBy", "subject", "title", "statusText"].includes(key)
        )
        .map((key) => rowMapper[key]);
    }
  };

  /* const parseRows = (rows) =>
    Object.keys(rows)
      .filter((key) =>
        ["department", "solver", "submittedBy", "subject", "title", "statusText"].includes(key)
      )
      .map((key) => rows[key]); */
  if (data.length > 0) {
    return (
      <div className="table-container">
        <table className={cleanJoin("table", "is-hoverable")} style={{ width: tableWidth }}>
          <Header columns={parseColumns(data[0])} />
          <TableRows rows={data} data={data} setTableWidth={setTableWidth} />
        </table>
      </div>
    );
  } else {
    return <h2 className="mt-6">Nema pronađenih podataka</h2>;
  }
}
export default ResultsTable;
